var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H10H15C17.7614 0 20 2.23858 20 5V9.99376C20 9.99584 20 9.99792 20 10C20 10.0021 20 10.0042 20 10.0062V15C20 17.7614 17.7614 20 15 20H10.0062C10.0042 20 10.0021 20 10 20C9.99792 20 9.99584 20 9.99376 20H5C2.23858 20 0 17.7614 0 15V10V5ZM13.8335 7.86456C13.8086 7.96402 13.7641 8.05749 13.7026 8.13949L9.85641 13.5241C9.79144 13.6149 9.70749 13.6904 9.61039 13.7455C9.51329 13.8006 9.40537 13.8338 9.29412 13.843C9.18286 13.8522 9.07095 13.837 8.96614 13.7986C8.86133 13.7602 8.76614 13.6994 8.68718 13.6205L6.37949 11.3128C6.24361 11.167 6.16964 10.9741 6.17315 10.7748C6.17667 10.5756 6.2574 10.3854 6.39834 10.2445C6.53927 10.1036 6.72941 10.0228 6.92869 10.0193C7.12798 10.0158 7.32085 10.0898 7.46667 10.2256L9.13231 11.8913L12.4513 7.24513C12.5089 7.16036 12.583 7.08797 12.669 7.03222C12.755 6.97646 12.8514 6.93847 12.9523 6.92047C13.0532 6.90248 13.1567 6.90484 13.2567 6.92741C13.3567 6.94999 13.4512 6.99233 13.5346 7.05195C13.618 7.11156 13.6887 7.18725 13.7424 7.27456C13.7962 7.36187 13.8319 7.45904 13.8475 7.56036C13.8632 7.66168 13.8584 7.76511 13.8335 7.86456Z",
    fill: "#0070FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/CheckboxChecked.0338a24df96968c56c8a0450484dcf5d.svg";
export { ForwardRef as ReactComponent };